import { gql } from 'apollo-boost';

export const getPageResumeQuery = gql`
  query Resume {
    Resume {
      educations {
        id
        university
        degree
        major
        start
        end
        isVisible
      }
      experiences {
        id
        company
        position
        start
        end
        description
        createDate
        isVisible
      }
      skills {
        id
        title
        rate
        createDate
        isVisible
      }
      achievements {
        id
        title
        where
        date
        createDate
        isVisible
      }
      projects {
        id
        title
        description
        shortLink
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        category {
          id
          title
        }
      }
      links {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      contacts {
        jobStatus
        bio
        cellphoneNumber
        emailAddress
        address
      }
    }
  }
`;

export const getPagePreviewResumeQuery = gql`
  query ResumePreview($pageName: String!) {
    ResumePreview(input: { pageName: $pageName }) {
      educations {
        id
        university
        degree
        major
        start
        end
      }
      experiences {
        id
        company
        position
        start
        end
        description
      }
      skills {
        id
        title
        rate
      }
      achievements {
        id
        title
        where
        date
      }
      projects {
        id
        title
        description
        shortLink
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        category {
          id
          title
        }
      }
      links {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      contacts {
        jobStatus
        bio
        cellphoneNumber
        emailAddress
        address
      }
      qrCodeUrl
    }
  }
`;

export const setResumeBioQuery = gql`
  mutation SetPageBio($value: String) {
    SetPageBio(input: { value: $value }) {
      value
    }
  }
`;

export const newResumeExperienceQuery = gql`
  mutation NewResumeExperience(
    $company: String!
    $position: String!
    $start: String
    $end: String
    $description: String
  ) {
    NewResumeExperience(
      input: {
        company: $company
        position: $position
        start: $start
        end: $end
        description: $description
      }
    ) {
      id
      company
      position
      start
      end
      description
      createDate
      isVisible
    }
  }
`;

export const editResumeExperienceQuery = gql`
  mutation EditResumeExperience(
    $id: ID!
    $company: String!
    $position: String!
    $start: String
    $end: String
    $description: String
  ) {
    EditResumeExperience(
      input: {
        id: $id
        company: $company
        position: $position
        start: $start
        end: $end
        description: $description
      }
    ) {
      id
      company
      position
      start
      end
      description
      createDate
      isVisible
    }
  }
`;

export const newResumeEducationQuery = gql`
  mutation NewResumeEducation(
    $university: String!
    $degree: String!
    $major: String!
    $start: String
    $end: String
  ) {
    NewResumeEducation(
      input: {
        university: $university
        degree: $degree
        major: $major
        start: $start
        end: $end
      }
    ) {
      id
      university
      major
      degree
      start
      end
      createDate
      isVisible
    }
  }
`;

export const editResumeEducationQuery = gql`
  mutation EditResumeEducation(
    $id: ID!
    $university: String!
    $degree: String!
    $major: String!
    $start: String
    $end: String
  ) {
    EditResumeEducation(
      input: {
        id: $id
        university: $university
        degree: $degree
        major: $major
        start: $start
        end: $end
      }
    ) {
      id
      university
      major
      degree
      start
      end
      createDate
      isVisible
    }
  }
`;

export const newResumeAchievementQuery = gql`
  mutation NewResumeAchievement(
    $title: String!
    $where: String!
    $date: String
  ) {
    NewResumeAchievement(input: { title: $title, where: $where, date: $date }) {
      id
      title
      where
      date
      createDate
      isVisible
    }
  }
`;

export const editResumeAchievementQuery = gql`
  mutation EditResumeAchievement(
    $id: ID!
    $title: String!
    $where: String!
    $date: String
  ) {
    EditResumeAchievement(
      input: { id: $id, title: $title, where: $where, date: $date }
    ) {
      id
      title
      where
      date
      createDate
      isVisible
    }
  }
`;

export const newResumeSkillQuery = gql`
  mutation NewResumeSkill($title: String!, $rate: Int!) {
    NewResumeSkill(input: { title: $title, rate: $rate }) {
      id
      title
      rate
      createDate
      isVisible
    }
  }
`;

export const editResumeSkillQuery = gql`
  mutation EditResumeSkill($id: ID!, $title: String!, $rate: Int!) {
    EditResumeSkill(input: { id: $id, title: $title, rate: $rate }) {
      id
      title
      rate
      createDate
      isVisible
    }
  }
`;

export const setPageContact = gql`
  mutation SetPageContact(
    $cellphoneNumber: String
    $emailAddress: String
    $address: String
  ) {
    SetPageContact(
      input: {
        cellphoneNumber: $cellphoneNumber
        emailAddress: $emailAddress
        address: $address
      }
    ) {
      cellphoneNumber
      emailAddress
      address
    }
  }
`;

export const editResumeLinks = gql`
  mutation EditResumeLinks($items: [ID]!) {
    EditResumeLinks(input: { items: $items }) {
      id
      title
      url
      logoName
      shortLinkUrl
    }
  }
`;

export const editResumeProjects = gql`
  mutation EditResumeProjects($items: [ID]!) {
    EditResumeProjects(input: { items: $items }) {
      id
      shortLink
      shortLinkUrl
      images {
        id
        url
        thumbnailUrl
      }
    }
  }
`;

export const setPageJobStatus = gql`
  mutation SetPageJobStatus($value: JobStatus!) {
    SetPageJobStatus(input: { value: $value }) {
      value
    }
  }
`;

export const reorderResumeItem = gql`
  mutation ReorderResumeItem(
    $id: ID!
    $newOrder: Int!
    $type: ResumeItemType!
  ) {
    ReorderResumeItem(input: { id: $id, newOrder: $newOrder, type: $type })
  }
`;

export const setResumeItemVisibilityQuery = gql`
  mutation SetResumeItemIsVisible($id: ID!, $isVisible: Boolean!) {
    SetResumeItemIsVisible(input: { id: $id, isVisible: $isVisible }) {
      id
      isVisible
      type
    }
  }
`;

export const removeResumeItemQuery = gql`
  mutation RemoveResumeItem($id: ID!) {
    RemoveResumeItem(input: { id: $id }) {
      id
      type
    }
  }
`;
